module.exports = __webpack_public_path__ + "static/media/Checkout-3.d267e162.png";